module.exports = __webpack_public_path__ + "img/PL08905.d65340b3.png";